function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import CustomerLocaleKeys from '../../../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { retrieveServiceDetails, searchServices, setSelectedServiceIdentifier } from '../../../../../reducers/actions/services.actions';
import { searchSubscriberOfferings } from '../../../../../reducers/actions/offering.order.actions';
import { OFFERING_STATUS_TYPES } from '../../../offerings/offerings.constants';
import { retrieveSubscriberOfferingDetail, setSelectedOfferingInstanceId, setServiceAndOfferWidgetSelectedTab } from '../../../../../reducers/actions/customer.actions';
import { CurrentCustomerCurrencyCodeSelector, CurrentCustomerIdSelector, RouteParams, SelectedTabServicesAndOffersSelector } from '../../../../../reducers/selectors/customer.selectors';
import { BulkServicesRecordCountSelector, ServicesWithFormattedServiceAttributeSelector } from '../../../../../reducers/selectors/services.selectors';
import { SelectedServiceIdentifierSelector, SelectedServiceThumbnailSelector } from '../../../../../reducers/selectors/selected.service.details.selectors';
import { SearchSubscriberOfferingsWithFormattedServiceIdentifierSelector, SelectedOfferingAndOptionsSelector, SelectedSubscriberOfferingInstanceIdSelector, SelectedSubscriberOfferingWithFormattedServiceSelector, SubsriberOfferingsPaginationDataSelector } from '../../../../../reducers/selectors/search.subscriber.offerings.selectors';
import { NUMBER_OF_CAROUSEL_ITEMS_TO_DISPLAY, NUMBER_OF_CAROUSEL_ITEMS_TO_FETCH, NUMBER_OF_ENTITLEMENTS_TO_DISPLAY, SERVICES_AND_OFFERS_TABS } from './services.and.offers.contants';
import { SERVICES_USAGE_STATE_NAME } from '../../../servicesAndUsage/services.and.usage.config';
import { OFFERINGS_STATE_NAME } from '../../../offerings/offerings.config';
import { TYPE_OF_SERVICE } from '../../../servicesAndUsage/servicesAndSharedEntitlements/services/services.list.constants';
import { formattedEntitlementsSelector } from '../../../../../reducers/selectors/shared.entitlements.selectors';
import { retrieveSharedEntitlements, setSelectedSharedEntitlementIndex } from '../../../../../reducers/actions/shared.entitlements.actions';
import { retrieveChangeOfferEligibilityRules } from '../../../../../reducers/actions/customer.offering.actions';
import { IsChangeOfferEligibilityRulesLoaded } from '../../../../../reducers/selectors/customer.offerings.selectors';
import { OfferEligibilityIdsSelector } from '../../../../../reducers/selectors/dashboard.selectors';
var ServicesAndOffersController = /*#__PURE__*/function () {
  function ServicesAndOffersController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ServicesAndOffersController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      fetchOffers: this.fetchOffers.bind(this),
      fetchServices: this.fetchServices.bind(this),
      isExpanded: true,
      NUMBER_OF_CAROUSEL_ITEMS_TO_DISPLAY: NUMBER_OF_CAROUSEL_ITEMS_TO_DISPLAY,
      NUMBER_OF_ENTITLEMENTS_TO_DISPLAY: NUMBER_OF_ENTITLEMENTS_TO_DISPLAY,
      OFFERINGS_STATE_NAME: OFFERINGS_STATE_NAME,
      onTabSelected: this.onTabSelected.bind(this),
      SERVICES_AND_OFFERS_TABS: SERVICES_AND_OFFERS_TABS,
      SERVICES_USAGE_STATE_NAME: SERVICES_USAGE_STATE_NAME,
      tabs: [],
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServicesAndOffersController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        retrieveChangeOfferEligibilityRules: retrieveChangeOfferEligibilityRules,
        retrieveServiceDetails: retrieveServiceDetails,
        retrieveSharedEntitlements: retrieveSharedEntitlements,
        retrieveSubscriberOfferingDetail: retrieveSubscriberOfferingDetail,
        searchServices: searchServices,
        searchSubscriberOfferings: searchSubscriberOfferings,
        setSelectedOfferingInstanceId: setSelectedOfferingInstanceId,
        setSelectedServiceIdentifier: setSelectedServiceIdentifier,
        setSelectedSharedEntitlementIndex: setSelectedSharedEntitlementIndex,
        setServiceAndOfferWidgetSelectedTab: setServiceAndOfferWidgetSelectedTab,
        stateGo: stateGo
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          allServices: ServicesWithFormattedServiceAttributeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          isChangeOfferEligibilityRulesLoaded: IsChangeOfferEligibilityRulesLoaded(store),
          isServiceLifeCycleStatusLoaded: MetadataCodeLoadedSelector(CODES.ServiceLifeCycleStatus, store),
          offeringsPaginationData: SubsriberOfferingsPaginationDataSelector(store),
          offersWithFormatedServices: SearchSubscriberOfferingsWithFormattedServiceIdentifierSelector(store),
          routeParams: RouteParams(store),
          selectedOffering: SelectedOfferingAndOptionsSelector(store),
          selectedOfferingInstanceId: SelectedSubscriberOfferingInstanceIdSelector(store),
          selectedServiceIdentifier: SelectedServiceIdentifierSelector(store),
          selectedServiceThumbnail: SelectedServiceThumbnailSelector(store),
          selectedSubscriberOfferingWithFormattedService: SelectedSubscriberOfferingWithFormattedServiceSelector(store),
          selectedTab: SelectedTabServicesAndOffersSelector(store),
          servicesRecordCount: BulkServicesRecordCountSelector(store),
          offerEligibilityIds: OfferEligibilityIdsSelector(store),
          sharedEntitlements: formattedEntitlementsSelector(store),
          subscriberCurrencyCode: CurrentCustomerCurrencyCodeSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.state.selectedTab) {
        this.tabs.map(function (tab) {
          tab.active = _this.state.selectedTab === tab.id;
          return tab;
        });
      }
      if (!this.state.isServiceLifeCycleStatusLoaded) {
        this.actions.fetchCodeTypes(CODES.ServiceLifeCycleStatus);
      }
      Promise.all([this.fetchServices(), this.fetchOffers(), this.fetchEntitlementBalances()]).then(function () {
        if (_this.state.allServices.serviceThumbnails.length) {
          _this.tabs.push({
            id: SERVICES_AND_OFFERS_TABS.WIDGET_SERVICES,
            name: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_AND_OFFERS_WIDGET.TABS.SERVICES),
            active: false
          });
        }
        if (_this.state.offersWithFormatedServices.length) {
          _this.tabs.push({
            id: SERVICES_AND_OFFERS_TABS.WIDGET_OFFERS,
            name: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_AND_OFFERS_WIDGET.TABS.OFFERS),
            active: false
          });
        }
        if (_this.state.sharedEntitlements.length) {
          _this.tabs.push({
            id: SERVICES_AND_OFFERS_TABS.WIDGET_SHARED_USAGE,
            name: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_AND_OFFERS_WIDGET.TABS.SHARED_USAGE),
            active: false
          });
        }
        if (_this.tabs.length) {
          _this.tabs[0].active = true;
          _this.onTabSelected(_this.tabs[0]);
        }
      });
      if (!this.state.isChangeOfferEligibilityRulesLoaded && this.state.offerEligibilityIds && this.state.offerEligibilityIds.length) {
        this.actions.retrieveChangeOfferEligibilityRules(this.state.currentCustomerId, this.state.offerEligibilityIds);
      }
    }
  }, {
    key: "onTabSelected",
    value: function onTabSelected(selectedTab) {
      this.actions.setServiceAndOfferWidgetSelectedTab(selectedTab.id);
      this.tabs = this.tabs.map(function (tab) {
        tab.active = selectedTab.id === tab.id;
        return tab;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "fetchServices",
    value: function fetchServices() {
      var _this2 = this;
      var params = Object.assign({}, this.state.routeParams, {
        serviceType: TYPE_OF_SERVICE.NON_BULK,
        pageNumber: 1,
        pageSize: NUMBER_OF_CAROUSEL_ITEMS_TO_FETCH
      });
      return this.actions.searchServices(params).catch(function (error) {
        return _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "fetchOffers",
    value: function fetchOffers() {
      var _this3 = this;
      var params = Object.assign({}, this.state.routeParams, {
        includeOfferingTotals: true,
        pageNumber: 1,
        pageSize: NUMBER_OF_CAROUSEL_ITEMS_TO_FETCH,
        status: [OFFERING_STATUS_TYPES.ACTIVE, OFFERING_STATUS_TYPES.PENDING_ACTIVE, OFFERING_STATUS_TYPES.PENDING_REMOVED, OFFERING_STATUS_TYPES.SUSPENDED, OFFERING_STATUS_TYPES.SUSPENSION_SCHEDULED]
      });
      return this.actions.searchSubscriberOfferings(params).then(function () {
        if (_this3.state.offersWithFormatedServices.length) {
          return _this3.actions.setSelectedOfferingInstanceId(_this3.state.offersWithFormatedServices[0].offerDetails.OfferingInstanceId);
        }
      }).catch(function (error) {
        return _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "fetchEntitlementBalances",
    value: function fetchEntitlementBalances() {
      var _this4 = this;
      return this.actions.retrieveSharedEntitlements(this.state.currentCustomerId).catch(function (error) {
        return _this4.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "fetchServiceDetails",
    value: function fetchServiceDetails() {
      var _this5 = this;
      if (this.state.selectedServiceIdentifier) {
        var serviceIdentifiers = [{
          Value: this.state.selectedServiceIdentifier
        }];
        this.actions.retrieveServiceDetails(this.state.currentCustomerId, serviceIdentifiers).catch(function (error) {
          _this5.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "refreshServices",
    value: function refreshServices() {
      this.fetchServices();
      this.fetchServiceDetails();
    }
  }, {
    key: "handleServiceSelected",
    value: function handleServiceSelected(service) {
      this.actions.setSelectedServiceIdentifier(service.ServiceIdentifier);
    }
  }, {
    key: "handleOfferingSelected",
    value: function handleOfferingSelected(offer) {
      this.actions.setSelectedOfferingInstanceId(offer.offerDetails.OfferingInstanceId);
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "onRefreshConvergentBillerDetails",
    value: function onRefreshConvergentBillerDetails() {
      this.refreshConvergentBillerDetails && this.refreshConvergentBillerDetails();
    }
  }]);
}();
export default {
  bindings: {
    displayOfferingsWidget: '<?',
    displayServicesAndOfferingsWidget: '<?',
    displayServicesWidget: '<?',
    refreshConvergentBillerDetails: '&?'
  },
  template: require('./services.and.offers.html'),
  controller: ServicesAndOffersController
};